/* import libraries */
import { useState, useEffect } from 'react';
import { useParams } from 'react-router';
import { useLocation, useSearchParams } from 'react-router-dom';

/* import components */
import Container from 'react-bootstrap/Container';
import Menu from '../components/Menu';
import TopicOption from "../components/TopicOption";
import TripSummary from '../components/TripSummary';
import Error from './Error';
import Loading from './Loading';

/* import services */
import tripsApi from '../api/tripsApi';
import { saveToken } from '../utils/utils';
import { serviceTypes } from '../utils/constants';
import SectionOption from '../components/SectionOption';

const TripDetails = () => {
    const { state } = useLocation();
    const { tripId, serviceType } = useParams();
    const [loadError, setLoadError] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const [trip, setTrip] = useState();
    const [isComplete, setIsComplete] = useState('Completed');
    const [loading, setLoading] = useState(true);

    const getTrip = async (tripId) => {
        try {
            setLoading(true)
            const response = await tripsApi.getTripById(tripId);
          if (response.status) {
            setTrip(response.data.data);
            setIsComplete(response.data.data.status)
            if (state?.trip) {
                state.trip.receiptNo = response.data.data?.receiptNo
            }
          } else {
            console.error(response.error.msg);
          }
        } catch (error) {
            setLoadError(true);
            console.error("Error while fetching trip: " + error.message)
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        // Save the token if opened from a mobile entry point
        if (searchParams.get("token")) {
            saveToken(searchParams.get("token"), setLoading);
        }

        // Need to get trip details to check trip status, to return the correct articles
        if (tripId) {
            getTrip(tripId);
        } else {
            setLoading(false);
        }
    }, []);

    if (loading) return <Loading />;
    if (loadError) return <Error />

    return (
        <>
            <Menu title={tripId && !serviceType ? "RydeHELP" : serviceType ? serviceTypes[`${serviceType.toLowerCase()}`] : state.topic.name} />
            <Container>
                {tripId && !serviceType ?
                    <>
                        <TripSummary trip={trip} />
                        <div className="grey font-bold" style={{ fontSize:"20px"}}>Related Issues</div>
                    </>
                    : <></>}
                {state ?
                // From webview home page
                <TopicOption
                    searchBar={false}
                    fontWeight="semibold"
                    trip={state.trip}
                    isComplete={isComplete} />
                :
                // From mobile trip details entry point
                <TopicOption
                    searchBar={false}
                    fontWeight="semibold"
                    tripIdFromUrl={tripId}
                    serviceTypeFromUrl={serviceType} /> }
                
                {
                  tripId && (
                    <SectionOption
                      fontWeight="semibold"
                      tripId={tripId}
                      serviceType={serviceType}
                      trip={trip}
                      />
                  )
                }
            </Container>
        </>
    );
}

export default TripDetails;
